import { useMutation, useQuery } from "react-query";
import API from "./utils/api";
import ENDPOINTS from "./utils/endpoints";
import {
	GhanaCardVerificationRequestDto,
	QueryMerchantCategoriesDto,
	VerifyBankAccountDto,
	VerifyMerchantDetailsDto,
} from "../models/miscellaneous.dto";

export function useListPaymentInstitutions(query?: any) {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.LIST_PAYMENT_INSTITUTIONS;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url, query],
		() => API.PaymentAPI.listPaymentInstitutions(query),
	);
	return { data, isLoading, error, refetch };
}

export function useGetPaymentTiers() {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_TIERS;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url],
		() => API.PaymentAPI.getTiers(),
	);
	return { data, isLoading, error, refetch };
}

export function useGetAvailablePaymentDestinations() {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_AVAILABLE_PAYMENT_DESTINATIONS;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url],
		() => API.PaymentAPI.getAvailablePaymentDestinations(),
	);
	return { data, isLoading, error, refetch };
}

export function useGetMerchantCategories(query?: QueryMerchantCategoriesDto) {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_MERCHANT_CATEGORIES;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url, query],
		() => API.PaymentAPI.getMerchantCategories(query),
	);
	return { data, isLoading, error, refetch };
}

export function useGetPaymentProducts() {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_PRODUCTS;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url],
		() => API.PaymentAPI.getProducts(),
	);
	return { data, isLoading, error, refetch };
}

export function useGetPaymentRegions() {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_REGIONS;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url],
		() => API.PaymentAPI.getRegions(),
	);
	return { data, isLoading, error, refetch };
}

export function useGetPaymentTags() {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_TAGS;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url],
		() => API.PaymentAPI.getTags(),
	);
	return { data, isLoading, error, refetch };
}

export function useGetPaymentCompanyTypes() {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_COMPANY_TYPES;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url],
		() => API.PaymentAPI.getCompanyTypes(),
	);
	return { data, isLoading, error, refetch };
}

export function useGetPaymentContactTypes() {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_CONTACT_TYPES;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url],
		() => API.PaymentAPI.getContactTypes(),
	);
	return { data, isLoading, error, refetch };
}

export function useGetSourceMerchants() {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_SOURCE_MERCHANTS;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url],
		() => API.PaymentAPI.getSourceMerchants(),
	);
	return { data, isLoading, error, refetch };
}

export function useGetSourceMerchantProducts(id: number) {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_SOURCE_MERCHANT_PRODUCTS;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url, id],
		() => API.PaymentAPI.getSourceMerchantProducts(id),
		{ enabled: !!id },
	);
	return { data, isLoading, error, refetch };
}

export function useGetSourceMerchantProduct(merchantProductId: string) {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_SOURCE_MERCHANT_PRODUCT;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url, merchantProductId],
		() => API.PaymentAPI.getSourceMerchantProduct(merchantProductId),
		{ enabled: !!merchantProductId },
	);
	return { data, isLoading, error, refetch };
}

export function useVerifyGhanaCard() {
	return useMutation(
		({ payload }: { payload: GhanaCardVerificationRequestDto }) =>
			API.PaymentAPI.verifyGhanaCard(payload),
			{ onError: API.Handlers.onErrorHandler },
	);
}

export function useViewGhanaCardVerification(requestId: string | number) {
	const url = ENDPOINTS.PAYMENTS.MISCELLANEOUS.VIEW_GHANA_CARD_VERIFICATION;
	const { data, isLoading, error, refetch } = useQuery<any, Error>(
		[url, requestId],
		() => API.PaymentAPI.viewGhanaCardVerification(requestId),
		{ enabled: !!requestId },
	);
	return { data, isLoading, error, refetch };
}

export function useVerifyMerchantDetails() {
	return useMutation(
		({ payload }: { payload: VerifyMerchantDetailsDto }) =>
			API.PaymentAPI.verifyMerchantDetails(payload),
			{ onError: API.Handlers.onErrorHandler },
	);
}

export function useVerifyBankAccount() {
	return useMutation(
		({ payload }: { payload: VerifyBankAccountDto }) =>
			API.PaymentAPI.verifyBankAccount(payload),
			{ onError: API.Handlers.onErrorHandler },
	);
}